module.exports = __webpack_public_path__ + "static/loockback-7e66a65e292ad802434fa006af2e8c01.png";